import { render, staticRenderFns } from "./OfferDialog.vue?vue&type=template&id=582a499e&scoped=true&"
import script from "./OfferDialog.vue?vue&type=script&lang=ts&"
export * from "./OfferDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyAndOffer.style.scss?vue&type=style&index=0&id=582a499e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582a499e",
  null
  
)

export default component.exports